var appConfig = {};

export default appConfig = {
    server : 'https://aclari.pl/',
    exitUrl : '/pierscionki-zareczyny/',
    currency : 'zł',
    discountValue : 0.00
};

